declare global {
  interface Window {
    Intercom?: ((command: string, settings?: Record<string, unknown> | ((...args: unknown[]) => void)) => void) & {
      q?: unknown[][]
    }
    intercomSettings?: Record<string, unknown>
  }
}

const installIntercomStub = (appId: string) => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('reattach_activator')
    window.Intercom('update', window.intercomSettings)
    return
  }
  const stub = function (...args: unknown[]) { stub.q!.push(args) } as NonNullable<Window['Intercom']>
  stub.q = []
  window.Intercom = stub
  window.intercomSettings = { app_id: appId }
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://widget.intercom.io/widget/${appId}`
  document.head.appendChild(script)
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const appId = config.public.intercomAppId as string | undefined
  if (!appId) { return }
  installIntercomStub(appId)
  window.Intercom!('boot', { app_id: appId, hide_default_launcher: true })
  useRouter().afterEach(() => {
    window.Intercom!('update')
  })
})
